export default (arr = [], limit = 10) =>
  arr.length > limit ? `${arr.slice(0, limit - 2).join(', ')}, and ${arr.length - limit - 2} more` : arr.join(', ');
